(function() {
    angular
        .module('rlt')
        .service('ExcludeResponsesService', ExcludeResponsesService)

    ExcludeResponsesService.$inject = [];

    function ExcludeResponsesService() {

        var svc = this;

        svc.onSubmit = onSubmit;
        svc.showDialog = showDialog;

        svc.isVisible = false;
        svc.callback = false;

        svc.responses = [];

        function showDialog( responses, callback ) {
            svc.responses = responses;
            svc.callback = callback;
            svc.isVisible = true;
        }

        function onSubmit( selectedResponses ) {
            svc.isVisible = false;
            svc.callback( selectedResponses );
        }
    }
})();

